'use client'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ChevronDown } from 'lucide-react'
import { useState } from 'react'

export default function FAQSection() {
    const [openIndex, setOpenIndex] = useState<number | null>(0)

    const faqs = [
        {
            question: "Зачем купить VPN и как он защищает данные?",
            answer: "Когда вы решаете купить VPN, вы получаете надёжную защиту конфиденциальности в интернете. VPN шифрует ваше соединение, скрывает реальный IP-адрес и позволяет обходить блокировки сайтов. Это особенно важно при подключении к публичным Wi-Fi сетям, где ваши данные могут быть перехвачены."
        },
        {
            question: "Что выгоднее: купить ключ VPN или оформить подписку?",
            answer: "Если вы планируете пользоваться VPN регулярно, лучше впн купить подписку — это дешевле в долгосрочной перспективе и удобнее, так как не нужно каждый раз продлевать доступ. Купить ключ впн стоит для разового использования или тестирования сервиса на короткий срок. В SkufVPN вы можете приобрести ключ с пробным периодом на 3 дня всего за 1 рубль"
        },
        {
            question: "Какой VPN купить для России и СНГ?",
            answer: "При выборе, какой впн купить, обратите внимание на наличие быстрых серверов, поддержку современных протоколов (WireGuard, Outline, VLESS) и стабильность работы в условиях блокировок. SKUF.VPN специально оптимизирован для пользователей из России и Казахстана, обеспечивая высокую скорость до 10 Гбит/сек."
        },
        {
            question: "Как купить VPN на ПК и установить его?",
            answer: "Купить впн на пк очень просто: выберите подходящий тариф, зарегистрируйтесь и получите ключ активации или ссылку для подключения. Установка занимает 2-3 минуты — достаточно импортировать конфигурацию в приложение WireGuard или использовать наш клиент. После этого ваше соединение будет защищено."
        },
        {
            question: "Что значит купить хороший VPN?",
            answer: "Купить хороший впн — это выбрать сервис с высокой скоростью, без логирования активности, защитой от утечек DNS и круглосуточной поддержкой. Важно, чтобы провайдер использовал современное шифрование и имел серверы в разных странах для стабильного доступа к любому контенту."
        },
        {
            question: "В чём преимущество, если VPN купить с протоколом WireGuard?",
            answer: "Если вы хотите wireguard vpn купить, вы получаете самый быстрый и современный протокол. WireGuard обеспечивает молниеносное подключение, низкую задержку и высокий уровень безопасности. Он оптимально работает как на мобильных устройствах, так и на компьютерах."
        },
        {
            question: "Можно ли купить аккаунт VPN для нескольких устройств?",
            answer: "Да, когда вы решаете vpn подписка купить, один аккаунт обычно работает на нескольких устройствах одновременно. Вы можете купить аккаунт vpn и использовать его на телефоне, ПК и планшете без дополнительных настроек. Это удобно для защиты всех ваших гаджетов."
        },
        {
            question: "Чем отличаются Outline VPN и VLESS VPN?",
            answer: "Если вы хотите outline vpn купить, вы получите решение с открытым исходным кодом, идеальное для корпоративного использования и команд. А если решите vless vpn купить, получите протокол нового поколения с максимальной устойчивостью к блокировкам и гибкими настройками для продвинутых пользователей."
        },
        {
            question: "Как быстро я получу доступ после покупки?",
            answer: "После того как вы решите vpn купить и оплатите тариф, доступ предоставляется моментально. Вы сразу получаете ключ активации или ссылку для подключения и можете начать пользоваться сервисом. Наша поддержка работает 24/7, если возникнут вопросы."
        }
    ]

    return (
        <div className='mb-20'>
            <div className='text-center mb-12'>
                <p className='text-white text-2xl uppercase mb-4' id='faq'>
                    {'[Часто задаваемые вопросы]'}
                </p>
                <h2 className='text-3xl md:text-4xl font-bold text-white mb-4'>
                    Всё, что нужно знать перед покупкой VPN
                </h2>
                <p className='text-gray-300 max-w-3xl mx-auto text-lg'>
                    Ответы на популярные вопросы о выборе, покупке и использовании VPN-сервиса
                </p>
            </div>

            <div className='max-w-4xl mx-auto space-y-4'>
                {faqs.map((faq, index) => (
                    <Card
                        key={index}
                        className='bg-black/50 backdrop-blur-sm border border-gray-800 hover:border-gray-700 transition-all duration-300'
                    >
                        <CardHeader
                            className='cursor-pointer'
                            onClick={() => setOpenIndex(openIndex === index ? null : index)}
                        >
                            <div className='flex justify-between items-center'>
                                <CardTitle className='text-lg md:text-xl text-white font-semibold pr-4'>
                                    {faq.question}
                                </CardTitle>
                                <ChevronDown
                                    className={`w-6 h-6 text-[#bfff01] transition-transform duration-300 flex-shrink-0 ${
                                        openIndex === index ? 'rotate-180' : ''
                                    }`}
                                />
                            </div>
                        </CardHeader>
                        {openIndex === index && (
                            <CardContent className='pt-0 pb-6'>
                                <p className='text-gray-300 leading-relaxed'>
                                    {faq.answer}
                                </p>
                            </CardContent>
                        )}
                    </Card>
                ))}
            </div>

            <div className='mt-12 text-center'>
                <p className='text-gray-400 mb-6 max-w-2xl mx-auto'>
                    Не нашли ответ на свой вопрос? Наша служба поддержки работает круглосуточно и готова помочь вам с выбором тарифа и настройкой VPN.
                </p>
                <a
                    href='https://t.me/skufhelp_bot'
                    className='inline-block bg-[#bfff01] text-black hover:bg-[#9fdf00] px-8 py-3 rounded-full transition-all duration-300 font-semibold'
                >
                    Связаться с поддержкой
                </a>
            </div>
        </div>
    )
}
